import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from '../fragments'

export const GET_PICOS_PRIORITIES_FOR_STORES = gql`
  query StorePicOSPriorities($input: StorePicOSPriorityInput!) {
    picosPrioritiesForStores(input: $input) {
      hasMore
      count
      results {
        ...PicOSPriority
      }
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
